import React from 'react';

export default function RequestError({ message, onRetry, busy = false }) {
  if (!message) return null;
  return <div role='alert' className='my-3 flex flex-wrap items-center gap-3 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800'>
    <span>{typeof message === 'string' ? message : 'Could not complete this request. Please try again.'}</span>
    {onRetry && <button type='button' className='rounded border border-red-300 bg-white px-3 py-1 disabled:opacity-50' disabled={busy} onClick={onRetry}>{busy ? 'Loading...' : 'Retry'}</button>}
  </div>;
}
